import { diffTimeMinutes } from '@utils/Format'

export const CLIENT_SCOPE = 'IS_CLIENT'

export const SCOPE_SEPARATOR = '|'

export const parseNaNSafe = (payload) =>
  typeof payload === 'string'
    ? JSON.parse(String(payload).split('NaN').join('null'))
    : payload

export const cloneDefensive = ({ payload, fallback } = {}) => {
  const sourceValue = payload === undefined ? fallback : payload

  try {
    return structuredClone(sourceValue)
  } catch {
    return fallback
  }
}

export const shouldUseCachedData = ({
  forceUpdate = false,
  lastUpdate,
  timeoutMinutes,
} = {}) => {
  if (forceUpdate) return false

  return !diffTimeMinutes(lastUpdate, timeoutMinutes)
}

export const resolveScopeKey = ({ isClient = false, id = null } = {}) =>
  isClient ? CLIENT_SCOPE : id

const GROUP_SCOPE_PREFIX = 'gf:'

export const buildGroupScopeKey = (idGrupoFamiliar) =>
  `${GROUP_SCOPE_PREFIX}${idGrupoFamiliar}`

export const parseScopeClientId = (scopeKey) =>
  String(scopeKey).split(SCOPE_SEPARATOR)[0]

export const isSameScope = (loadedKey, currentKey) =>
  String(loadedKey) === String(currentKey)

export const hasCachedPayload = (payload) => {
  if (!payload) return false

  return Array.isArray(payload)
    ? payload.length > 0
    : Object.keys(payload).length > 0
}

export const buildApiErrorResponse = ({
  error,
  fallbackStatus = 500,
  fallbackMessage = 'Erro inesperado.',
  fallbackValue = null,
} = {}) => {
  const status =
    (error && error.response && error.response.status) ||
    (error && error.status) ||
    fallbackStatus

  const message = (error && error.message) || fallbackMessage

  return {
    status,
    message,
    value: fallbackValue,
  }
}

export const normalizeConcurrentRequest = async ({
  request,
  fallbackMessage,
} = {}) => {
  try {
    return await request
  } catch (error) {
    return buildApiErrorResponse({
      error,
      fallbackMessage,
    })
  }
}

export const buildRequestKey = ({ scopeKey, params } = {}) =>
  [String(scopeKey), JSON.stringify(params || {})].join(SCOPE_SEPARATOR)

export const dedupeInFlight = async ({ registry = {}, key, run } = {}) => {
  if (registry.inFlight && registry.key === key) {
    return registry.inFlight
  }

  const emVoo = run()
  registry.key = key
  registry.inFlight = emVoo
  try {
    return await emVoo
  } finally {
    if (registry.inFlight === emVoo) {
      registry.inFlight = null
      registry.key = null
    }
  }
}

export const claimLatestRequest = (registry = {}) => {
  registry.latest = (registry.latest || 0) + 1
  const requestId = registry.latest
  return { isStale: () => requestId !== registry.latest }
}
